export default function ReturnGuide() {
  const tips = [
    {
      icon: 'ri-store-2-line',
      title: '特約店を活用する',
      description: 'コンビニ、スーパー、ガソリンスタンドなど、よく使うお店が特約店になっているカードを選びましょう。還元率が2〜7倍になります。'
    },
    {
      icon: 'ri-shopping-cart-line',
      title: 'ネットショッピングで貯める',
      description: 'ECモールやAmazon、Yahoo!ショッピングなど、よく使うECサイトで高還元になるカードを選ぶのがコツです。'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'スマホ決済と組み合わせる',
      description: 'Apple PayやGoogle Payと組み合わせることで、さらにポイント還元率がアップするカードもあります。'
    },
    {
      icon: 'ri-calendar-line',
      title: 'ポイント有効期限に注意',
      description: '高還元率でも有効期限が短いと失効してしまいます。有効期限が長い、または無期限のカードがおすすめです。'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h3 className="text-3xl font-bold text-center mb-4 text-[#003366]">
          ポイントを最大限貯めるコツ
        </h3>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          高還元率カードを選ぶだけでなく、使い方を工夫することでさらにポイントが貯まります。
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {tips.map((tip, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-[#FFB800] to-[#FFA000] rounded-full flex items-center justify-center mb-4">
                <i className={`${tip.icon} text-white text-2xl w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <h4 className="text-xl font-bold mb-3 text-[#003366]">{tip.title}</h4>
              <p className="text-gray-700 leading-relaxed">{tip.description}</p>
            </div>
          ))}
        </div>

        {/* Comparison Table */}
        <div className="mt-16">
          <h4 className="text-2xl font-bold text-center mb-8 text-[#003366]">
            還元率比較シミュレーション
          </h4>
          <div className="bg-white rounded-xl p-8 shadow-md max-w-4xl mx-auto">
            <p className="text-center text-gray-600 mb-6">
              月10万円利用した場合の年間ポイント獲得額
            </p>
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#FFB800] to-[#FFA000] rounded-full flex items-center justify-center">
                    <span className="text-white font-bold">1%</span>
                  </div>
                  <span className="font-medium text-gray-700">還元率1%のカード</span>
                </div>
                <span className="text-2xl font-bold text-[#FFB800]">12,000円</span>
              </div>
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#14B8A6] to-[#0F9B8E] rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-sm">0.5%</span>
                  </div>
                  <span className="font-medium text-gray-700">還元率0.5%のカード</span>
                </div>
                <span className="text-2xl font-bold text-gray-500">6,000円</span>
              </div>
              <div className="text-center pt-4 border-t border-gray-200">
                <p className="text-lg font-bold text-[#FFB800]">
                  年間6,000円の差！高還元率カードがお得
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <a
            href="#ranking"
            className="inline-block bg-[#FFB800] text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#FFA000] transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            高還元率カードを今すぐチェック
          </a>
        </div>
      </div>
    </section>
  );
}
